

const InformationBar = () => {
    return (
        <div className="information-bar">
            Api may be slow so wait for some time for it to get load
        </div>
    );
};

export default InformationBar;